import React from 'react';
import { formatDate, formatPrice, LISTING_TYPE_LABELS } from '../utils/formatters';
import { POST_EXPIRY_DAYS } from '../constants/limits';
import './MedallionListItem.css';

const MedallionListItem = ({
  post,
  userId,
  userRole,
  onViewDetails,
  onEdit,
  onDelete,
  onRenew
}) => {
  const isSell = post.listing_type === 'sell';
  const isAdmin = userRole === 'admin';
  const isOwnPost = post.user_id === userId;

  const getBorderClass = () => `status-${post.status}`;

  return (
    <div className={`medallion-card ${getBorderClass()} ${isOwnPost ? 'my-post' : ''}`}>
      {/* Left Icon Panel */}
      <div className={`medallion-icon-panel ${isSell ? 'sell-type' : 'buy-type'}`}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.5"/>
          <circle cx="12" cy="12" r="7.5" fill="none" stroke="currentColor" strokeWidth="1"/>
          <text x="12" y="16" textAnchor="middle" fontSize="11" fontWeight="700" fill="currentColor" stroke="none">M</text>
        </svg>
        <span className="icon-label">
          {isSell ? 'Selling' : 'Buying'}
        </span>
      </div>

      {/* Right Content Panel */}
      <div className="medallion-content">
        {/* Title Row */}
        <div className="medallion-title-row">
          <div className="medallion-title-info">
            <h3 className="medallion-title">{post.title}</h3>
            <div className="medallion-meta">
              {!isOwnPost && post.poster_name && <span>by {post.poster_name}</span>}
              {post.price && <span className="medallion-price">{formatPrice(post.price)}</span>}
            </div>
          </div>

          <div className="medallion-actions">
            {!isOwnPost && !isAdmin && onViewDetails && (
              <button className="btn-action btn-primary" onClick={() => onViewDetails(post)}>
                Details
              </button>
            )}
            {isOwnPost && onRenew && (
              <button className="btn-action btn-renew" onClick={() => onRenew(post.id)}>
                Renew
              </button>
            )}
            {isOwnPost && onEdit && (
              <button className="btn-action btn-secondary" onClick={() => onEdit(post)}>
                Edit
              </button>
            )}
            {isOwnPost && onDelete && (
              <button className="btn-action btn-danger" onClick={() => onDelete(post.id)}>
                Delete
              </button>
            )}
            {isAdmin && !isOwnPost && (
              <>
                {onViewDetails && (
                  <button className="btn-action btn-primary" onClick={() => onViewDetails(post)}>
                    Details
                  </button>
                )}
                {onEdit && (
                  <button className="btn-action btn-secondary" onClick={() => onEdit(post)}>
                    Edit
                  </button>
                )}
                {onDelete && (
                  <button className="btn-action btn-danger" onClick={() => onDelete(post.id)}>
                    Delete
                  </button>
                )}
              </>
            )}
          </div>
        </div>

        {/* Description */}
        {post.description && (
          <p className="medallion-description">{post.description}</p>
        )}

        {/* Tags Row */}
        <div className="medallion-tags">
          <span className={`tag tag-listing ${post.listing_type}`}>
            {LISTING_TYPE_LABELS[post.listing_type] || post.listing_type}
          </span>

          {post.price && (
            <span className="tag tag-price">{formatPrice(post.price)}</span>
          )}

          {post.quantity > 1 && (
            <span className="tag tag-quantity">Qty: {post.quantity}</span>
          )}

          {isOwnPost && post.days_until_expiry !== undefined && (
            <span className={`tag tag-time ${post.days_until_expiry <= 3 ? 'expiring' : ''}`}>
              {post.days_until_expiry <= 0 ? 'Expiring today' : `${post.days_until_expiry}d left`}
            </span>
          )}
        </div>

      </div>
    </div>
  );
};

export default MedallionListItem;
